import { Dialog, DialogContent } from './dialog';
import Button from './Button';
import { Heart } from 'lucide-react';

interface SupportPopupProps {
    isOpen: boolean;
    onClose: () => void;
    onSupportClick: () => void;
    creatorName: string;
}

export default function SupportPopup({
    isOpen,
    onClose,
    onSupportClick,
    creatorName
}: SupportPopupProps) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <div className="relative">
                    {/* Content */}
                    <div className="text-center pt-6 pb-8">
                        {/* Icon */}
                        <div className="mx-auto w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mb-6">
                            <Heart className="h-8 w-8 text-white" />
                        </div>

                        {/* Title */}
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">
                            Support this athlete's sport
                        </h2>

                        {/* Description */}
                        <p className="text-gray-600 mb-8 leading-relaxed">
                            Join {creatorName} on their sporting journey and help make a difference in their future.
                            Your support helps fund their training and gives you access to exclusive content and updates.
                        </p>

                        {/* CTA Button */}
                        <Button
                            onClick={() => {
                                onClose();
                                onSupportClick();
                            }}
                            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105"
                        >
                            See Support Options
                        </Button>

                        {/* Additional text */}
                        <p className="text-sm text-gray-500 mt-4">
                            Choose from flexible support levels that work for you
                        </p>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
